import script from "./Sinter.vue?vue&type=script&setup=true&lang=js"
export * from "./Sinter.vue?vue&type=script&setup=true&lang=js"

import "./Sinter.vue?vue&type=style&index=0&id=ffcaeff6&scoped=true&lang=css"
import "./Sinter.vue?vue&type=style&index=1&id=ffcaeff6&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ffcaeff6"]])

export default __exports__